import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=3ec9dae3&scoped=true"
import script from "./product-card.component.js?vue&type=script&lang=js&external"
export * from "./product-card.component.js?vue&type=script&lang=js&external"
import style0 from "./product-card.vue?vue&type=style&index=0&id=3ec9dae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec9dae3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItemAvatar,VListItemContent})
